import Api from './index';

const getUserClassrooms = (params: any) => Api.get(`users/me/classrooms`, { params });

export { getUserClassrooms };
